import {LogRespuestaOSE} from "./LogRespuestaOSE";
import {LogEmailSend} from "./LogEmailSend";
import {Emisor} from "../../../../../seguridad/emisor/recursos/modelo/emisor";

export class LogEmisor {

    public requestType: string;
    public numRuc: string;
    public fechaEmisionCPE: string;
    public requestAddress: string;
    public password: string;
    public ticket: string;
    public fileContent: string;
    public respuesta: LogRespuestaOSE[];
    public respuestaString: string;
    public emisor: any;
    public seleccionado: boolean;
    public linkRequestPSE: string;
    public linkRequestXML: string;
    public linkResponseCDR: string;
    public linkResponsePDF: string;
    public estado: string;

    public pseRequest: any;

    public id: number;
    public correlativo: number;
    public documentType: string;
    public document: string;
    public emisorNombre: string;
    public emisorRUC: string;
    public fechaEmision: string;
    public fileName: string;
    public moneda: string;
    public montoImporte: string;
    public numSerie: string;
    public receptorNombre: string;
    public receptorRuc: string;
    public requestDate: string;
    public responseCode: string;
    public responseMessage: string;
    public responseStatus: string;
    public username: string;
    public totalDescuento: number;
    public totalExonerado: number;
    public totalGravado: number;
    public totalIGV: number;
    public totalInafecto: number;
    public totalGratuito: number;
    public comprobantes: any;
    public observations: string;
    public logEmailSend: LogEmailSend[];


    constructor(id: number = null,
                requestDate: string = "",
                requestType: string = "",
                documentType: string = "",
                numRuc: string = "",
                requestAddress: string = "",
                username: string = "",
                password: string = "",
                ticket: string = "",
                fileName: string = "",
                fileContent: string = "",
                respuesta: LogRespuestaOSE[] = [],
                respuestaString: string = "",
                emisor: any = new Emisor(),
                fechaEmisionCPE: string = "",
                estado: string = "ACEPTADO",
                pseRequest: any = {id: null},
                comprobantes: any = [],
                observations: string = null) {
        this.id = id;
        this.requestDate = requestDate;
        this.requestType = requestType;
        this.documentType = documentType;
        this.numRuc = numRuc;
        this.requestAddress = requestAddress;
        this.username = username;
        this.password = password;
        this.ticket = ticket;
        this.fileName = fileName;
        this.fileContent = fileContent;
        this.respuesta = respuesta;
        this.respuestaString = respuestaString;
        this.emisor = emisor;
        this.seleccionado = false;
        this.fechaEmisionCPE = fechaEmisionCPE;
        this.linkRequestPSE = null;
        this.linkRequestXML = "";
        this.linkResponseCDR = "";
        this.linkResponsePDF = "";
        this.pseRequest = pseRequest;
        this.estado = estado;
        this.observations = observations;

    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/transaccion/emisorTerceros/cmp-list-detalle-lote/recursos/modelo/LogEmisor.ts